import {
  isLocationFilterActive,
  locationFiltersToApiParams,
} from "./locationFilterUtils";

export const EMPTY_LOCATION_FILTER_API_PARAMS = Object.freeze({});

/** Fresh mutable empty selection for React state (never reuse frozen arrays). */
export function createEmptyDocumentLibrarySelectedIds() {
  return {
    docType: [],
    provider: [],
    status: [],
    services: [],
  };
}

/** Map selected service ids to API service names for POST /Documents. */
export function buildDocumentLibraryServiceNames(selectedServiceIds, rfis) {
  if (!selectedServiceIds?.length) {
    return [];
  }

  return selectedServiceIds.map((serviceId) => {
    const service = rfis?.find(
      (rfi) =>
        rfi.rfi_id === serviceId ||
        rfi.id === serviceId ||
        rfi.hash_id === serviceId
    );
    return (
      service?.services || service?.rfi_name || service?.name || serviceId
    );
  });
}

/**
 * Avoid flashing previous filter results/pagination while the next query loads
 * (keepPreviousData / placeholderData).
 */
export function shouldShowDocumentLibraryLoading({
  isFetching,
  isPlaceholderData,
}) {
  return Boolean(isFetching || isPlaceholderData);
}

/** Stable empty params object so query keys do not churn on `{}` identity. */
export function toStableLocationFilterParams(locationFilters) {
  const params = locationFiltersToApiParams(locationFilters);
  if (
    !params.country_list?.length &&
    !params.state_list?.length &&
    !params.city_list?.length
  ) {
    return EMPTY_LOCATION_FILTER_API_PARAMS;
  }
  return params;
}

/**
 * Clearing location must bypass debounce: otherwise UI looks cleared while
 * results/pagination stay on the previous applied location for 300ms+.
 */
export function shouldFlushLocationFiltersImmediately(
  nextLocationFilters,
  appliedLocationFilters
) {
  return (
    !isLocationFilterActive(nextLocationFilters) &&
    isLocationFilterActive(appliedLocationFilters)
  );
}

export function hasExtraDocumentLibraryFilters({
  locationFilters,
  archiveStatusFilter,
  isCatalogAdmin,
}) {
  return (
    isLocationFilterActive(locationFilters) ||
    (Boolean(isCatalogAdmin) && archiveStatusFilter !== "active_only")
  );
}
